import { firestoreCollections } from '@creative-kit/shared';
import { db as firestoreDb } from 'firebase-modules';
import type firebase from 'firebase';

export const db = firestoreCollections<firebase.firestore.Firestore>(firestoreDb);
